export const config = {
    debugMode: false,
    symbols: {
        ES: {
            pricePerPoint: 50,
        },
        MES: {
            pricePerPoint: 5,
        },
        NQ: {
            pricePerPoint: 20,
        },
        MNQ: {
            pricePerPoint: 2,
        },
        CL: {
            pricePerPoint: 1000,
        },
        MCL: {
            pricePerPoint: 100,
        },
        GC: {
            pricePerPoint: 100,
        },
        MGC: {
            pricePerPoint: 10,
        },
        ZN: {
            pricePerPoint: 1000,
        },
        MZN: {
            pricePerPoint: 100,
        },
        YM: {
            pricePerPoint: 5,
            tickValue: 1,
        },
        MYM: {
            pricePerPoint: 0.50,
            tickValue: 1,
        },
    },
}